import { render, staticRenderFns } from "./FormRadioOptionsArray.vue?vue&type=template&id=2b4fb66e&"
import script from "./FormRadioOptionsArray.vue?vue&type=script&lang=js&"
export * from "./FormRadioOptionsArray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports